// Libraries
import { SetStateAction, useState } from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

// MUI
// Core
import { ResourceTextApplication } from '../../core/resources';
import FormValidator from '../../core/FormValidator';
import auth from '../../core/authorization';

// Common
import { ASearchIconButton } from '../buttons';
import { ADateInput } from '../inputs';

// Interfaces
// Store
// API
// Feature
import DisplayAll from '../../animals/announcements/components/list-view/components/control/DisplayAll';

export interface ISearchCalendarProps {
    handleSort: () => void;
    handleFromDateChange: (fromDate: moment.Moment) => void;
    handleToDateChange: (toDate: moment.Moment) => void;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    className: string;
    childrenText: string;
    fromDateId: string;
    toDateId: string;
    displayAll?: boolean;
    setDisplayAll?: (val: boolean) => void
}

export default function SearchCalendar(props: ISearchCalendarProps) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaBovine', 'AnelmaGeneral']);
    const validator = new FormValidator();

    const setDateRangeToLastWeek = () => {
        const lastWeekStart = moment().subtract(1, 'week').startOf('day');
        const lastWeekEnd = moment().startOf('day');
        props.handleFromDateChange(lastWeekStart);
        props.handleToDateChange(lastWeekEnd);
    };

    const setDateRangeToLastYear = () => {
        const yearAgo = moment().subtract(1, 'year').startOf('day');
        const todayEnd = moment().startOf('day');
        props.handleFromDateChange(yearAgo);
        props.handleToDateChange(todayEnd);
    };

    const handleDisplayAllChange = (value: boolean) => {
        if (value) {
            setDateRangeToLastWeek();
        } else {
            setDateRangeToLastYear();
        }

        if (props.setDisplayAll)
            props.setDisplayAll(value);
    };

    return (
        <Grid container spacing={0} sx={{ paddingBottom: '20px' }}>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <Typography
                    className={props.className}
                    variant='subtitle1'
                    children={props.childrenText}
                />
            </Grid>

            <Grid size={{ xs: 3, sm: 3, md: 3, lg: 3 }}>
                <ADateInput
                    id={props.fromDateId}
                    label={t('AnelmaGeneral:1090')}
                    onChange={(_) => props.handleFromDateChange(moment(_))}
                    validator={validator}
                    value={props.fromDate.toDate()}
                    disabled={props.displayAll}
                />
            </Grid>
            <Grid size={{ xs: 3, sm: 3, md: 3, lg: 3 }}>
                <ADateInput
                    id={props.toDateId}
                    label={t('AnelmaGeneral:1091')}
                    onChange={(_) => props.handleToDateChange(moment(_))}
                    validator={validator}
                    value={props.toDate.toDate()}
                    disabled={props.displayAll}
                />
            </Grid>
            <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }}>
                <ASearchIconButton
                    onClick={() => props.handleSort()}
                    type='action'
                    tooltip={t('AnelmaGeneral:1055')}
                    style={{ marginTop: '12px' }}
                />
            </Grid>
            {auth.canViewAllAnimalAnnouncementsFromListView
                && props.displayAll !== undefined ? (
                    <DisplayAll
                        handleClick={handleDisplayAllChange}
                        checked={props.displayAll ?? false}
                    />
                ) : null}
        </Grid>
    );
}
